<section class="card p-6">

    <div class="grid grid-cols-1 gap-6">

      <div class="col-span-3">
        <div class="flex justify-between">
            <h2 class="text-xl font-semibold">Ecosystem</h2>
            <app-edit-button *ngIf="edit" [edit]="edit"></app-edit-button>
        </div>
      </div>

      <!-- Customers -->
      <!--
      <div class="hidden">
        <div class="col-span-3 xl:col-span-1">

          <h3 class="text-base font-semibold pb-6" >Customers</h3>

          <div *ngIf="report.search_person.enhanced_data?.organization?.customers">
              <p class="text-xs mb-3">{{ ecosystem.customers?.small_description }}</p>

              <div class="mb-3">
                  <div *ngFor="let customer of customers; index as i;" class="pills">
                          <span class="flex items-center text-xs text-secondary-900">
                              {{ customer?.name  ?? ''}}
                          </span>
                  </div>
                  <div>
                      <a href="#" class="text-xs text-blue-custom underline">View full list</a>
                  </div>
              </div>

              <div class="blue-card p-3">
                  <p class="text-sm">{{ ecosystem.customers?.description }}</p>
              </div>
          </div>

        </div>
      </div>
      -->
      <!-- / Customers -->

      <!-- Providers -->
      <!--
      <div class="hidden">
        <div class="col-span-3 xl:col-span-1">

          <h3 class="text-base font-semibold pb-6">Providers</h3>

          <div *ngIf="report.search_person.enhanced_data?.organization?.providers">
            <p class="text-xs mb-3">{{ ecosystem?.providers?.small_description }}</p>

            <div class="mb-3">
              <div *ngFor="let provider of providers; index as i;" class="pills">
                <span class="flex items-center text-xs text-secondary-900">
                    {{ provider?.name ?? ''}}
                </span>
              </div>
              <div>
                <a href="#" class="text-xs text-blue-custom underline">View full list</a>
              </div>
            </div>

            <div class="blue-card p-3">
                <p class="text-sm">{{ ecosystem?.providers?.description }}</p>
            </div>
          </div>

        </div>
      </div>
      -->
      <!-- / Providers -->

      <!-- Used technologies -->
      <div class="col-span-3 xl:col-span-1">
        <h3 class="text-base font-semibold pb-6">Used technologies</h3>

        <div *ngIf="company?.technologies.length > 0">
          <div *ngFor="let technology of company?.technologies;" class="pills">
            <span class="flex items-center text-xs text-secondary-900">
                {{ technology ?? ''}}
            </span>
          </div>
        </div>

        <div *ngIf="company?.technologies.length === 0">
          <p class="text-xs !text-gray-500">Used technoologies not found.</p>
        </div>

      </div>
      <!-- / Used technologies -->

    </div>

</section>
